<label class="checkbox" tabindex="0">
  <input type="checkbox" [(ngModel)]="checked" (change)="onChange(checked)" />
  <i>
    <span class="icon icon-8" [inlineSVG]="'check.svg'"></span>
  </i>
  <span>
    <ng-content></ng-content>
  </span>
</label>
